import {ImportModel} from "../../models/import/ImportModel";
import {BaseEntity} from "../../entities/BaseEntity";
import { StateService } from "@uirouter/angularjs";

export class ImportUploadFileCtrl<T extends BaseEntity> {
    mytest = "my test";
    content:string = "";
    separator:string=",";
    result:any = "";
    public static $inject = ['$scope','$state','ImportModel'];
    constructor(public $scope:any, public stateService:StateService, public model:ImportModel<T>) {
        this.$scope.vm = this;
        this.$scope.$watch(() => this.model.csvData,(newValue: string, oldValue: string) => {
            if(newValue != oldValue) {
                this.model.getImportFields().then(()=>{
                    this.model.getColumns();
                    this.stateService.go(this.model.getRoute("mapfields"));
                })
                .catch((exc)=>{
                    alert("got exception in getImportFields:"+exc);
                });
            }
        });
    }
    updateLocation():void{
    }
}
